// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5 1.5H11C12.1 1.5 13 2.4 13 3.5V12.5C13 13.6 12.1 14.5 11 14.5H5C3.9 14.5 3 13.6 3 12.5V3.5C3 2.4 3.9 1.5 5 1.5Z',
  'M8 11.5H8.01',
];
